import { createActions } from '../helpers/redux';

export const ModalActions = createActions({
  toggleModal(modal) {
    return {
      modal,
    };
  },

  revealModal() {
    return {};
  },

  hideModal() {
    return {};
  },

  backModal() {
    return {};
  },
});



// WEBPACK FOOTER //
// ./src/actions/modal.js